import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

export const _account = [
  {
    label: 'پروفایل من',
    href: paths.dashboard.profile,
    icon: <Iconify icon="solar:user-id-bold-duotone" />,
  },
  {
    label: 'داشبورد',
    href: paths.dashboard.root,
    icon: <Iconify icon="solar:widget-5-bold-duotone" />,
  },
];
